import React, {useCallback, useContext, useEffect, useReducer, useRef, useState} from 'react';
import {BaseStyle} from "../../../styles/shared/BaseStyle";
import useGetAllPrenotazioni from "./utils/useGetAllPrenotazioni";
import {onClickDetails} from "../../../services/AutomationServices";
import {addDayToDate, clean, getAccountInfo} from "../../../utils/GenericUtils";
import {setOpenSnackbar} from "../../../services/AppServices";
import {AUTOMATION_INITIAL_STATE, AutomationReducer, initAutomationState} from "../../../reducers/AutomationReducer";
import {AppContext} from "../../../App";
import HideAppBar from "../../widgets/header/HideAppBar";
import {
	Button,
	Card, CardActions,
	CardContent,
	CardHeader,
	Collapse,
	Container, DialogActions, Divider,
	FormControl,
	InputLabel, MenuItem,
	Paper, Select,
	TextField
} from "@mui/material";
import Grid from "@mui/material/Grid";
import clsx from "clsx";
import PrenotazioniDrawer from "./drawer/PrenotazioniDrawer";
import {useHistory} from "react-router-dom";
import PrenotazioneCard from "./detail/PrenotazioneCard";
import { Alert, AlertTitle, Skeleton } from '@mui/material';
import AddAgendaCard from "./section/AddAgendaCard";
import VisualizzaAgende from "./section/VisualizzaAgende";
import InputAdornment from "@mui/material/InputAdornment";
import Tooltip from "@mui/material/Tooltip";
import IconButton from "@mui/material/IconButton";
import SearchTwoToneIcon from "@mui/icons-material/SearchTwoTone";
import FilterListTwoToneIcon from "@mui/icons-material/FilterListTwoTone";
import {ContattaciStyle} from "../../../styles/pages/contact/ContattaciStyle";
import SimpleDialog from "../../widgets/dialogs/SimpleDialog";
import {KeyboardDatePickerCompat} from "../../widgets/inputs/KeyboardDatePickerCompat";
import itLocale from "date-fns/locale/it";
import {sendPDF} from "../../../services/TamponiServices";
import moment from "moment";
import {initTamponiState, TAMPONI_INITIAL_STATE, TamponiReducer} from "../../../reducers/TamponiReducer";
import {useForm} from "react-hook-form";
import CustomText from "../../widgets/inputs/CustomText";
import CustomDateInput from "../../widgets/inputs/CustomDateInput";
import {useSessionStorage} from "../../../utils/hooks/SessionStorageHook";

const GestionePrenotazioni = () => {
	const classes = BaseStyle();
	const contattaciClasses = ContattaciStyle();
	const appContext = useContext(AppContext);
	const [stato, setStato] = useSessionStorage("statoPre", "Odierni");
	const [active, setActive] = useSessionStorage("active", "false");
	const [searchObject, setSearchObject] = useSessionStorage("search", {});
	const [priority, setPriority] = useSessionStorage("priority", "Normale");
	const [criterioEpidem, setCriterioEpidem] = useSessionStorage("criterioEpidem", "");
	const [contattoRichiedente, setContattoRichiedente] = useSessionStorage("contattoRich", null);
	const [luogo, setLuogo] = useSessionStorage("luogoPrenot", "Agenda personale");
	const {getValues, control, errors, watch, reset} = useForm({
		mode: "onChange",
		defaultValues: sessionStorage.getItem("search") ? {search: JSON.parse(sessionStorage.getItem("search"))} : {}
	});
	let history = useHistory();
	const [pageNumber, setPageNumber] = useState(0);
	const [automationState, automationDispatch] = useReducer(AutomationReducer, AUTOMATION_INITIAL_STATE, initAutomationState);
	const [state, dispatch] = useReducer(TamponiReducer, TAMPONI_INITIAL_STATE, initTamponiState);
	const [selected, setSelected] = useState("");
	const [sort, setSort] = useState("dataRichiesta");
	const [dir, setDir] = useState("ASC");
	const [open, setOpen] = useState(false);
	const [value, setValue] = useState("");
	const [showDialog, setShowDialog] = useState(false);
	const [selectedDate, handleDateChange] = useState(new Date(addDayToDate(new Date(), 1)));
	const [submit, setSubmit] = useState(false);
	const observer = useRef();
	const {
		loading,
		error,
		hasMore,
		prenotazioni
	} = useGetAllPrenotazioni(stato, pageNumber, value, sort, dir, open, searchObject, priority, active, criterioEpidem, contattoRichiedente, luogo)

	const setMenuSelected = useCallback((newValue) => {
		setPageNumber(0);
		setStato(newValue);
	}, [setStato]);

	const setActiveFilter = useCallback((newValue) => {
		setPageNumber(0);
		setActive(newValue);
	}, [setActive]);

	const setPriorityFilter = useCallback((newValue) => {
		setPageNumber(0);
		setPriority(newValue);
	}, [setPriority]);

	const lastTicketElementRef = useCallback(node => {
		if (loading) return
		if (observer.current) observer.current.disconnect()
		observer.current = new IntersectionObserver(entries => {
			if (entries[0].isIntersecting && hasMore) {
				setPageNumber(prevState => prevState + 1);
			}
		})
		if (node) observer.current.observe(node)
	}, [loading, hasMore])

	const goToPrenotazione = useCallback((prenotazione) => {
		setSelected(prenotazione)
		onClickDetails(prenotazione.id, "prenotazioneTamponi", "modify", automationDispatch);
	}, [automationDispatch])

	const scaricaPrenotazioni = useCallback(() => {
		setSubmit(true);
		sendPDF(moment(selectedDate).format("DD-MM-YYYY"), dispatch)
	}, [dispatch, selectedDate])

	const onSearch = useCallback(() => {
		if (open) {
			let soggetto = getValues()?.["search"];
			setSearchObject(clean(soggetto));
			setPageNumber(0);
		}
	}, [open, getValues, setSearchObject])

	const handleKeyDown = useCallback((event) => {
		if ((event.ctrlKey && event.keyCode === 13) || event.keyCode === 13) {
			onSearch();
		}
	}, [onSearch])

	useEffect(() => {
		if (!automationState.loadingOnClick && automationState.errorOnClick === "") {
			if (automationState.operatorOnClick.replace("ERR_", "").includes(getAccountInfo().alias)) {
				history.push("/gestione/prenotazioni/" + selected.id);
			} else {
				setOpenSnackbar("warning", ("La prenotazione è al momento gestita da " + automationState.operatorOnClick?.replace("ERR_", "") + ". Ritenta e sari più fortunato :)"), appContext.dispatch)
			}
		}
	}, [automationState.loadingOnClick, automationState.errorOnClick, automationState.operatorOnClick, selected, history, appContext.dispatch])

	useEffect(() => {
		if (submit && !state.loadingSendPDF && state.errorSendPDF === "") {
			setSubmit(false);
			setOpenSnackbar("success", "Email inviata correttamente", appContext.dispatch);
		} else if (submit && !state.loadingSendPDF && state.errorSendPDF !== "") {
			setSubmit(false);
			setOpenSnackbar("error", state.errorSendPDF, appContext.dispatch);
		}
	}, [submit, state.loadingSendPDF, state.errorSendPDF, appContext.dispatch])

	useEffect(() => {
		setPageNumber(0);
	}, [sort, dir, value, open, searchObject, priority, criterioEpidem, contattoRichiedente, luogo])


	useEffect(() => {
		document.body.style = `background-image: none`;
	}, []);

	return (
        <React.Fragment>
            <main className={classes.main}>
				<HideAppBar title={"Appuntamenti ed agende"}/>
				<Container maxWidth={"xl"} component={"article"} style={{paddingTop: 12}}>
					<Grid container spacing={3}>

						<Grid item xs={12}>
							<Paper
								className={clsx(classes.roundBorder, classes.filterSearchPaper)}
								component={"section"}>
								<TextField
									placeholder={"Cerca per Codice fiscale o molto altro andando ad aprire il filtro (bottone a destra)"}
									value={value}
									onChange={(e) => setValue(e.target.value)}
									autoFocus={true}
									fullWidth={true}
									variant={"outlined"}
									InputProps={{
										startAdornment: <InputAdornment position="start">
											<Tooltip title={"Cerca"}>
												<IconButton color="inherit" onClick={onSearch} size="large">
													<SearchTwoToneIcon/>
												</IconButton>
											</Tooltip>
										</InputAdornment>,
										endAdornment: <InputAdornment position="start">
											<Tooltip title={"Ricerca avanzata"}>
												<IconButton
                                                    color="inherit"
                                                    onClick={() => {
                                                        setOpen(!open)
                                                    }}
                                                    className={clsx(classes.expand, {
                                                        [classes.expandOpen]: open,
                                                    })}
                                                    size="large">
													<FilterListTwoToneIcon/>
												</IconButton>
											</Tooltip>
										</InputAdornment>,
										classes: {notchedOutline: contattaciClasses.noBorder},
									}}
								/>
								<Collapse in={open} timeout="auto" unmountOnExit>
									<Grid container spacing={3} className={classes.padding2}>
										<Grid item xs={12} sm={6}>
											<FormControl variant="outlined" fullWidth>
												<InputLabel id="sort">Ordina per</InputLabel>
												<Select
													labelId="sort"
													id="sort"
													value={sort}
													onChange={(e) => setSort(e.target.value)}
													label="Ordina per"
												>
													<MenuItem value={"dataRichiesta"}>Data richiesta</MenuItem>
													<MenuItem value={"dataEffettiva"}>Data effettiva</MenuItem>
													<MenuItem value={"dataInserimento"}>Data inserimento</MenuItem>
													<MenuItem value={"dataUltimaModifica"}>Data ultima modifica</MenuItem>
													<MenuItem value={"luogo"}>Luogo</MenuItem>
													<MenuItem value={"lastModify"}>Operatore ultima modifica</MenuItem>
												</Select>
											</FormControl>
										</Grid>
										<Grid item xs={12} sm={6}>
											<FormControl variant="outlined" fullWidth>
												<InputLabel id="dir">Ascendente / Discendente</InputLabel>
												<Select
													labelId="dir"
													id="dir"
													value={dir}
													onChange={(e) => setDir(e.target.value)}
													label="Ascendente / Discendente"
												>
													<MenuItem value={"ASC"}>Dal più piccolo al più grande</MenuItem>
													<MenuItem value={"DESC"}>Dal più grande al più piccolo</MenuItem>
												</Select>
											</FormControl>
										</Grid>
										<Grid item xs={12}>
											<Divider/>
										</Grid>
										<Grid item xs={12} sm={2}>
											<CustomText
												control={control}
												rules={{required: false}}
												name={"search.id"}
												label={"ID"}
												autoFocus={false}
												type={"number"}
												handleKeyDown={handleKeyDown}
												error={errors["search"]?.["id"]}
											/>
										</Grid>
										<Grid item xs={12} sm={4}>
											<CustomText
												control={control}
												rules={{required: false}}
												name={"search.codF"}
												label={"Codice fiscale"}
												autoFocus={false}
												handleKeyDown={handleKeyDown}
												error={errors["search"]?.["codF"]}
											/>
										</Grid>
										<Grid item xs={12} sm={3}>
											<CustomDateInput
												label={"Data richiesta"}
												control={control}
												defaultValue={null}
												rules={{required: true}}
												name={"search.dataRichiesta"}
												error={errors["search"]?.["dataRichiesta"]}
											/>
										</Grid>
										<Grid item xs={12} sm={3}>
											<CustomDateInput
												label={"Data effettiva"}
												control={control}
												defaultValue={null}
												rules={{required: true}}
												name={"search.dataEffettiva"}
												error={errors["search"]?.["dataEffettiva"]}
											/>
										</Grid>
										<Grid item xs={12} sm={4}>
											<CustomText
												control={control}
												rules={{required: false}}
												name={"search.cognome"}
												label={"Cognome"}
												handleKeyDown={handleKeyDown}
												autoFocus={false}
												error={errors["search"]?.["cognome"]}
											/>
										</Grid>
										<Grid item xs={12} sm={4}>
											<CustomText
												control={control}
												rules={{required: false}}
												name={"search.nome"}
												label={"Nome"}
												handleKeyDown={handleKeyDown}
												autoFocus={false}
												error={errors["search"]?.["nome"]}
											/>
										</Grid>
										<Grid item xs={12} sm={4}>
											<CustomText
												control={control}
												rules={{required: false}}
												name={"search.cell"}
												label={"Cellulare"}
												handleKeyDown={handleKeyDown}
												autoFocus={false}
												error={errors["search"]?.["cell"]}
											/>
										</Grid>
										<Grid item xs={12} className={classes.flexRight}>
											<Button variant={"text"} disableElevation style={{borderRadius: 24, marginLeft: 5}}
											        onClick={() => {
												        reset();
												        setSearchObject({})
												        sessionStorage.removeItem("search");
											        }}>
												<b>Rimuovi filtri</b>
											</Button>
											<Button variant={"contained"} disableElevation color={"primary"} onClick={onSearch}
											        style={{borderRadius: 24, marginLeft: 5}}>
												<b>Cerca</b>
											</Button>
										</Grid>
									</Grid>
								</Collapse>
							</Paper>
						</Grid>

						<Grid item xs={12}>

							<Card className={clsx(classes.roundBorder)}
							      style={{height: "100%", display: "flex", flexDirection: "column"}}>
								<CardContent style={{flexGrow: 1, display: "flex"}}>

									<PrenotazioniDrawer stato={stato} selectMenuItem={setMenuSelected}
									                    setActiveFilter={setActiveFilter} active={active}
									                    priority={priority} handlePriority={setPriorityFilter}
									                    criterio={criterioEpidem} setCriterio={setCriterioEpidem}
									                    dataRichiesta={watch("search")?.dataRichiesta}
									                    contattoRich={contattoRichiedente} setContattoRich={setContattoRichiedente}
									                    luogo={luogo} setLuogo={setLuogo}
									/>

									{
										stato === "Crea agenda" && <div className={classes.content}>
											<AddAgendaCard/>
										</div>
									}
									{
										stato === "Visualizza agende" && <div className={classes.content}>
											<VisualizzaAgende/>
										</div>
									}
									{stato !== "Crea agenda" && stato !== "Visualizza agende" &&
										<div className={classes.content}
										     style={{
											     maxHeight: "80vh",
											     overflowY: "auto",
											     overflowX: "hidden",
										     }}>
											{
												prenotazioni.map((prenotazione, index) => {
													if (prenotazioni.length === index + 1) {
														return (
															<Card ref={lastTicketElementRef} key={prenotazione.id}
															      className={clsx(classes.roundBorder, classes.mailCard)}>
																<PrenotazioneCard prenotazione={prenotazione} goToPrenotazione={goToPrenotazione}/>
															</Card>
														)
													} else {
														return (
															<Card key={prenotazione.id}
															      className={clsx(classes.roundBorder, classes.mailCard)}>
																<PrenotazioneCard prenotazione={prenotazione} goToPrenotazione={goToPrenotazione}/>
															</Card>
														)
													}
												})
											}

											{!loading && !error && prenotazioni.length === 0 &&
												<Alert severity="info" style={{borderRadius: 24}}>
													<AlertTitle>Evvai 😇!!</AlertTitle>
													Non ci sono prenotazioni! Goditi questo meritato relax
												</Alert>}
											{!loading && error &&
												<Alert severity="error" style={{borderRadius: 24}}>
													<AlertTitle>Errore</AlertTitle>
													Prova ad effettuare un refresh della pagina entro 5 minuti. Se l'errore persiste contatta gli
													sviluppatori.
												</Alert>}
											{loading &&
												<Card className={clsx(classes.roundBorder, classes.mailCard)} elevation={0}>
													<CardHeader
														avatar={<Skeleton variant="circular" height={40} width={40}/>}
														title={<Skeleton width={180}/>}
														subheader={<Skeleton width={260}/>}
														action={<Skeleton variant="circular" height={20} width={20}/>}
														style={{paddingBottom: 2}}
													/>
													<CardContent style={{paddingTop: 0, marginTop: -35}}>
														<Skeleton height={200}/>
													</CardContent>
												</Card>}

										</div>}

								</CardContent>
								<CardActions className={classes.flexRight}>
									<Tooltip
										title={"Invia email con prenotazioni. Le attuali prenotazioni concluse diventeranno gestite."}>
										<Button className={classes.roundButton} style={{borderRadius: 24}} variant={"contained"}
										        size={"small"} disableElevation color={"primary"} onClick={() => setShowDialog(true)}>
											<b>Scarica ed invia prenotazioni</b>
										</Button>
									</Tooltip>
								</CardActions>
							</Card>
						</Grid>
					</Grid>
				</Container>

				{
					showDialog &&
					<SimpleDialog
						open={showDialog}
						handleClose={() => setShowDialog(!showDialog)}
						maxWidth={"md"}
						title={"Per che data desideri effettuare lo scarico?"}
						content={
							<Grid container spacing={3}>
								<Grid item xs={12}>
									<KeyboardDatePickerCompat
											inputVariant="outlined"
											value={selectedDate}
											locale={itLocale}
											style={{width: "100%"}}
											label={"Seleziona una data"}
											onChange={date => handleDateChange(date)}
											format="dd/MM/yyyy"
											showTodayButton={true}
											todayLabel={"OGGI"}
											cancelLabel={"CANCELLA"}
											clearable={false}
										/>
								</Grid>
							</Grid>
						}
						actions={
							<DialogActions>
								<Button className={classes.roundButton} style={{borderRadius: 24}} variant={"text"}
								        size={"small"} disableElevation onClick={() => setShowDialog(false)}>
									<b>Annulla</b>
								</Button>
								<Button className={classes.roundButton} style={{borderRadius: 24}} variant={"contained"}
								        size={"small"} disableElevation color={"primary"} onClick={scaricaPrenotazioni}>
									<b>Conferma</b>
								</Button>
							</DialogActions>
						}
					/>
				}

			</main>
        </React.Fragment>
    );
}

export default React.memo(GestionePrenotazioni);
